import { getApiUrl } from "../../constants/pathConstants"
import { SearchOption, searchStateData } from "../../data/searchStateData"
import { API_END_POINT_INSTRUCTOR_SEARCH } from "../endPoints"
import { InstructorSearchResponse } from "../types"

class InstructorSearchConnector {
	requestInProgress: boolean = false

	// constructor() {
	// }

	public async performSearchRequest(): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InstructorSearchConnector] performSearchRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				if (searchStateData.searchResultProfiles.length > 0) {
					urlParams.append("in", searchStateData.searchResultProfiles.length.toString())
				}

				searchStateData.quickSearchOptions.forEach((searchOption: SearchOption) => {
					if (searchOption.value !== undefined) {
						urlParams.append(searchOption.queryParam, searchOption.value.toString())
					}
				})

				searchStateData.subFilterOptions.forEach((searchOption: SearchOption) => {
					if (searchOption.value !== undefined) {
						urlParams.append(searchOption.queryParam, searchOption.value.toString())
					}
				})

				let headers = new Headers();

				headers.append('Content-Type', 'application/json')
				headers.append('Accept', 'application/json')

				
				// headers.append('Access-Control-Allow-Origin', '*')
				// headers.append('Access-Control-Allow-Credentials', 'true')

				// headers.append('GET','POST')
				// headers.append('GET', 'POST', 'OPTIONS')

				// headers.append('Authorization', 'Basic ' + base64.encode(username + ":" + password));

				await fetch(`${getApiUrl()}${API_END_POINT_INSTRUCTOR_SEARCH}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: InstructorSearchResponse) => {
						if (data.profiles) {
							searchStateData.addSearchProfiles(data.profiles)
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			return false
		}
	}

	public async performExploreSearchRequest(): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [InstructorSearchConnector] performExploreSearchRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true

				let headers = new Headers();

				headers.append('Content-Type', 'application/json')
				headers.append('Accept', 'application/json')

				await fetch(`${getApiUrl()}${API_END_POINT_INSTRUCTOR_SEARCH}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: InstructorSearchResponse) => {
						if (data.profiles) {
							searchStateData.addExplorePopularProfiles(data.profiles)
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				await fetch(`${getApiUrl()}${API_END_POINT_INSTRUCTOR_SEARCH}?ge=0`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: InstructorSearchResponse) => {
						if (data.profiles) {
							searchStateData.addExploreMaleProfiles(data.profiles)
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				await fetch(`${getApiUrl()}${API_END_POINT_INSTRUCTOR_SEARCH}?ge=1`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: InstructorSearchResponse) => {
						if (data.profiles) {
							searchStateData.addExploreFemaleProfiles(data.profiles)
						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			return false
		}
	}
}

export const instructorSearchConnector: InstructorSearchConnector = new InstructorSearchConnector()

// OLD
// fetch('/api')
		// 	.then((res) => res.json())
		// 	.then((data) => setResData(data.message))
		// 	.catch((error) => {
		// 		console.log(error)
		// 		setResData('Failed to get data')
		// 	})
		
		// fetch('/instructors', {
		// 	method: 'POST',
		// 	headers: {
		// 		"Content-Type": "application/json",
		// 	},
		// 	body: JSON.stringify({
		// 		searchParm: 'test'
		// 	})
		// })
		// 	.then((res) => res.json())
		// 	.then((data) => setResData(data.message))
		// 	.catch((error) => {
		// 		console.log(error)
		// 		setResData('Failed to get data')
		// 	})